import {Dialog}from '@mui/material';
import { ButtonStyled, CapitalizeWord, ChipStyled, ContentStyled, DescriptionStyled, PopupTitle, WrapperActions} from './StartQuizPopup.styled.js';
import { CATEGORY } from '../../utils/constants.js';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/authContext.jsx';

export const StartQuizPopup = ({ isOpenPopup, onClosePopup, infoQuiz }) => { 

    const { category, year } = infoQuiz;
    const { isAuthenticated } = useAuth();

    return (
        <Dialog open={isOpenPopup}>

            <PopupTitle>
                Sei pronto per iniziare il Quiz?
            </PopupTitle> 
            
            <ContentStyled>
        
                <ChipStyled label={<CapitalizeWord>{category}</CapitalizeWord>} color='base' />
                <ChipStyled label={year} color='base'/>
                <ChipStyled label={`${category===CATEGORY.ECOLIER?24:30} quesiti`}color='base'/>
                <ChipStyled label={'75 minuti'} color='base'/>      
                   
            </ContentStyled>
            {!isAuthenticated &&
                <>
                    <DescriptionStyled><b>Registrati ora!</b></DescriptionStyled>
                    <DescriptionStyled><b>Studente:</b> salva i tuoi quiz, monitora i risultati e segui i tuoi progressi con facilità!</DescriptionStyled>
                    <DescriptionStyled><b>Insegnante:</b> crea classroom, aggiungi studenti e gestisci i quiz in un click.</DescriptionStyled>
                </>}
            
            
            <WrapperActions >
                {!isAuthenticated && <ButtonStyled component={Link} to='/register' variant="contained" color='benjamin' onClick={onClosePopup}>registrati o accedi</ButtonStyled>}
                <ButtonStyled variant="contained" color='benjamin' onClick={onClosePopup}>start</ButtonStyled>
                <ButtonStyled component={Link} to='/simulation' variant="outlined" color='benjamin' onClick={onClosePopup}>indietro</ButtonStyled>
            </WrapperActions>

        </Dialog>
    );
};